import { createContext } from 'react'

/**
 * A tuple of `[state code, state name]`.

 * @example ['CA', 'California']
 */
export type StateLookupTuple = [string, string]
export type StateLookupArray = StateLookupTuple[]

export const StatesContext = createContext<StateLookupArray>([])
